// extracted by mini-css-extract-plugin
module.exports = {"controlsView":"CategorySelectModal_controlsView__2cjEw"};